import Login from "./Components/Authentication/Login";
import Navbar from "./Components/Global/Navbar";
import { BrowserRouter as Main, Routes, Route } from "react-router-dom";
import SignUp from "./Components/Authentication/Sign-Up";
import Footer from "./Components/Global/Footer";
import NotFound404 from "./Components/Error/NotFound404";
import Home from "./Components/Home";
import "remixicon/fonts/remixicon.css";
import About from "./Components/About";
import { EmailVerificationPage } from "./Components/Authentication/EmailVerificationPage";
import userGuide from "./Components/userGuide";
import { Dashboard } from "./Components/LoggedInComponents/Dashboard";
import { shallowEqual, useSelector } from "react-redux";
import Profile from "./Components/LoggedInComponents/Profile";
import ProfileDelete from "./Components/LoggedInComponents/ProfileDelete";
import Account from "./Components/LoggedInComponents/Account";
import { useEffect } from "react";
import LoadingBar from "react-top-loading-bar";
import Alert from "./Components/Helper/Alert";
import ForgotPassword from "./Components/ForgotPassword";

function App() {
  // * user have login ?
  const userLogin = useSelector((state) => state.user).login;
  const logInRequest = useSelector((state) => state.logIn);
  const userRefreshTokenIsValid = useSelector(
    (state) => state.user
  ).refreshTokenIsValid;

  useEffect(() => {
    shallowEqual();
  }, [userLogin, logInRequest, userRefreshTokenIsValid]);

  // * Get state from redux store for [loadingBarProgress]
  const loadingBarProgress = useSelector(
    (state) => state.loadingBarProgress
  ).progress;
  return (
    <div className="App">
      <Main>
        <Navbar />
        <LoadingBar
          color="#f11946"
          height={2}
          loaderSpeed={700}
          progress={loadingBarProgress}
        />
        <Alert
          message={
            "Your session has expired. Please log in again to continue accessing your account."
          }
        />

        <Routes>
          {/* Public Components */}
          <Route path="/" Component={Home}></Route>
          <Route exact path="/about" Component={About}></Route>
          <Route exact path="/user-guide" Component={userGuide}></Route>
          <Route exact path="/login" Component={Login}></Route>
          <Route exact path="/signup" Component={SignUp}></Route>
          <Route
            exact
            path="/emailverification"
            Component={EmailVerificationPage}
          ></Route>
          <Route path="/forgot-password" Component={ForgotPassword}></Route>

          {/*  LoggedIn Components */}
          {userLogin && (
            <>
              <Route
                exact
                path="/account/dashboard"
                Component={Dashboard}
              ></Route>
              <Route exact path="/account" Component={Account}></Route>
              <Route exact path="/account/profile" Component={Profile}></Route>
              <Route
                exact
                path="/account/profile/overview"
                Component={Profile}
              ></Route>
              <Route
                exact
                path="/account/profile/info"
                Component={Profile}
              ></Route>
              <Route
                exact
                path="/account/profile/settings"
                Component={Profile}
              ></Route>
              <Route
                exact
                path="/account/profile/database-api-key"
                Component={Profile}
              ></Route>
              <Route
                exact
                path="/account/profile/delete"
                Component={ProfileDelete}
              ></Route>
            </>
          )}
          {/* Error Component*/}

          <Route path="*" Component={NotFound404}></Route>
        </Routes>
        <Footer />
      </Main>
    </div>
  );
}

export default App;
